import { render } from "./HistoricoDatos.vue?vue&type=template&id=305a9f9f"
import script from "./HistoricoDatos.vue?vue&type=script&lang=js"
export * from "./HistoricoDatos.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__